import axios from "axios";
import { apiWrapWithErrorWithData, headersProvider } from "../apiHelpers";
import constants from "../constants";

export const createAgreement = ({ agreementData, ...restArgs }) =>
  axios.post(
    `${constants.apiHost}/agreements/new-agreement`,
    {
      agreementData,
      ...restArgs,
    },
    {
      headers: headersProvider(),
    },
  );

export const draftAgreemntsApi = () =>
  axios.post(
    `${constants.apiHost}/agreements/draft-agreements`,
    {},
    {
      headers: headersProvider(),
    },
  );
export const getAgreementWorkflow = () =>
  axios.get(`${constants.apiHost}/agreement/workflow`, {
    headers: headersProvider(),
  });

export const getAgreementsList = ({
  page,
  sortByOptions,
  filterOptions,
  pageSize,
  listType,
  signal,
}) =>
  axios.post(
    `${constants.apiHost}/agreements/list`,
    {
      page,
      filterOptions,
      sortByOptions,
      pageSize,
      listType,
    },
    {
      headers: headersProvider(),
      signal,
    },
  );

export const getAgreementPartyNames = ({ search, listType } = {}) =>
  axios.post(
    `${constants.apiHost}/agreements/party-names`,
    { search, listType },
    {
      headers: headersProvider(),
    },
  );

export const getAllAgreementsList = ({ page, sortByOptions, filterOptions }) =>
  axios.post(
    `${constants.apiHost}/allagreements/list`,
    {
      page,
      filterOptions,
      sortByOptions,
    },
    {
      headers: headersProvider(),
    },
  );
export const getAgreementInRenewalsList = ({
  page,
  sortByOptions,
  filterOptions,
  tabName,
}) =>
  axios.post(
    `${constants.apiHost}/agreements/Renewal-List`,
    {
      page,
      filterOptions,
      sortByOptions,
      tabName,
    },
    {
      headers: headersProvider(),
    },
  );

export const fetchRenewalsCSV = ({ tabName }) =>
  axios.post(
    `${constants.apiHost}/agreements/Renewal-List-csv`,
    { tabName },
    {
      headers: headersProvider(),
    },
  );
export const getDocLockerList = ({
  page,
  sortByOptions,
  filterOptions,
  pageSize,
}) =>
  axios.post(
    `${constants.apiHost}/agreements/DocLockerList`,
    {
      page,
      filterOptions,
      sortByOptions,
      pageSize,
    },
    {
      headers: headersProvider(),
    },
  );
export const agreementTranSaveApi = (agreementTran) =>
  axios.post(
    `${constants.apiHost}/agreement/tran`,
    {
      ...agreementTran,
    },
    {
      headers: headersProvider(),
    },
  );

export const updateAgreement = ({
  agreementId,
  agreementData,
  noOfCompletionDays,
  ...restArgs
}) =>
  axios.put(
    `${constants.apiHost}/agreements/update/${agreementId}`,
    {
      agreementData,
      ...restArgs,
      noOfCompletionDays,
    },
    {
      headers: headersProvider(),
    },
  );

export const businessUnitDetails = ({ businessUnitId }) =>
  axios.get(`${constants.apiHost}/businessunitdetails/${businessUnitId}`, {
    headers: headersProvider(),
  });

export const orgDetailsUpdate = ({ orgDetails, orgName }) =>
  axios.put(
    `${constants.apiHost}/updateOrg`,
    { orgName, orgDetails },
    {
      headers: headersProvider(),
    },
  );

export const getOrgDetails = () =>
  axios.get(`${constants.apiHost}/orgDetails`, {
    headers: headersProvider(),
  });

export const saveCafData = ({ agreementId, cafData }) =>
  axios.put(
    `${constants.apiHost}/agreements/updatecaf/${agreementId}`,
    { cafData },
    {
      headers: headersProvider(),
    },
  );

export const sendAgainToReview = ({ agreementId }) =>
  axios.put(
    `${constants.apiHost}/agreements/reviewagain`,
    { agreementId },
    { headers: headersProvider() },
  );

export const uploadFromLocal = ({ agreementId, formData }) =>
  axios.post(
    `${constants.apiHost}/agreement/upload-from-local/${agreementId}`,
    formData,
    {
      headers: headersProvider(),
    },
  );

export const getAgreementDetails = ({ agreementId }) =>
  axios.get(`${constants.apiHost}/agreements/details/${agreementId}`, {
    headers: headersProvider(),
  });

export const getDocsToken = () =>
  axios.get(`${constants.apiHost}/docs/fetchTokenMS`, {
    headers: headersProvider(),
  });

export const getUserByRole = ({ roleId }) =>
  axios.get(`${constants.masterApi}/base-backend/user/by-role/${roleId}`, {
    headers: headersProvider(),
  });

export const sendReminderId = ({ signatureId }) =>
  axios.get(
    `${constants.apiHost}/agreements/details/sendReminder/${signatureId}`,
    {
      headers: headersProvider(),
    },
  );
export const putflowJson = (id, flowJsonData) =>
  axios.put(
    `${constants.apiHost}/agreement/flowJsonUpdate/${id}`,
    {
      flowJsonData,
    },
    {
      headers: headersProvider(),
    },
  );
export const putLegacyFlowJson = (id, flowJsonData) =>
  axios.put(
    `${constants.apiHost}/agreement/legacyFlowJsonUpdate/${id}`,
    {
      flowJsonData,
    },
    {
      headers: headersProvider(),
    },
  );

// export const deleteAgreementDetails = ({
//   agreementId,
// }) => axios.put(`${constants.apiHost}/agreements/delete`, {
//   agreementId,
// }, {
//   headers: headersProvider(),
// });

export const deleteAgreementBulk = ({ agreementIds }) =>
  axios.put(
    `${constants.apiHost}/agreements/delete`,
    {
      agreementIds,
    },
    {
      headers: headersProvider(),
    },
  );

export const deleteAgreement = ({ agreementId }) =>
  axios.put(
    `${constants.apiHost}/deleteagreement`,
    {
      agreementId,
    },
    {
      headers: headersProvider(),
    },
  );

export const createSigningRequest = (emails) =>
  axios.post(
    "https://w6bduqd0tj.execute-api.us-east-1.amazonaws.com/default/signer-proxy",
    {
      emails,
    },
    {
      noTrailingSlash: true,
    },
  );

const b64toUrl = async (base64Data) => {
  const r = await fetch(base64Data);
  const blob = await r.blob();
  return URL.createObjectURL(blob);
};
export const getGoogleDocsPreviewUrl = async (agreementId) => {
  let url = null;
  const data = await apiWrapWithErrorWithData(
    axios.get(
      `${constants.apiHost}/docs/fetchDocsContentBase64/${agreementId}`,
      {
        headers: headersProvider(),
      },
    ),
  );
  if (data.success && data.fileString) {
    url = await b64toUrl(data.fileString);
  }
  return { url, base64File: data?.fileString };
};
export const getPreviewUrl = async (delta) => {
  let url = null;
  const data = await apiWrapWithErrorWithData(
    axios.post(`${constants.apiHost}/utilities/common/get-pdf-in-base64`, {
      quillDelta: delta,
    }),
  );
  if (data.success && data.fileString) {
    url = await b64toUrl(data.fileString);
  }
  return { url, base64File: data?.fileString };
};

export const getPreviewUrlofFile = ({ key }) =>
  axios.post(
    `${constants.apiHost}/agreements/previewurl`,
    {
      key: key,
    },
    {
      headers: headersProvider(),
    },
  );

export const getAgreementSignStatusApi = ({ agreementId }) =>
  axios.get(`${constants.apiHost}/agreements/sign-details/${agreementId}`, {
    headers: headersProvider(),
  });
export const getAgreementAuditLog = async ({ agreementId }) =>
  await axios.get(`${constants.apiHost}/agreement/AuditLogs/${agreementId}`, {
    headers: headersProvider(),
  });

export const getRelatedAgreement = async ({ agreementId }) =>
  await axios.get(`${constants.apiHost}/agreement/ByRelation/${agreementId}`, {
    headers: headersProvider(),
  });

export const sendAgreementForSignature = ({
  signers,
  agreementId,
  ...params
}) =>
  axios.post(
    `${constants.apiHost}/agreements/sign-initiate/${agreementId}`,
    {
      ...params,
      signers,
    },
    {
      headers: headersProvider(),
    },
  );

export const cancelAgreementSignature = ({ agreementId }) =>
  axios.post(
    `${constants.apiHost}/agreements/sign-cancel/${agreementId}`,
    {},
    {
      headers: headersProvider(),
    },
  );

export const restartAgreementSignature = ({ agreementId }) =>
  axios.post(
    `${constants.apiHost}/agreements/sign-restart/${agreementId}`,
    {},
    {
      headers: headersProvider(),
    },
  );

export const agreementAnalytics = () =>
  axios.get(`${constants.apiHost}/agreements/analytics`, {
    headers: headersProvider(),
  });

export const getTotalAgreementsList = ({ filterOptions, year }) =>
  axios.post(
    `${constants.apiHost}/agreements/TotalList`,
    {
      page: 1,
      filterOptions: filterOptions,
      sortByOptions: { createdAt: "desc" },
      year,
    },
    {
      headers: headersProvider(),
    },
  );
export const getTotalAgreementsListType = ({ filterOptions, year }) =>
  axios.post(
    `${constants.apiHost}/agreements/TotalListType`,
    {
      page: 1,
      filterOptions: filterOptions,
      sortByOptions: { createdAt: "desc" },
      year,
    },
    {
      headers: headersProvider(),
    },
  );

export const getAgreementsInReviewList = ({
  page,
  pageSize,
  filterOptions,
  sortByOptions,
  range,
}) =>
  axios.post(
    `${constants.apiHost}/agreements/CollaborationList`,
    { page: page, filterOptions, sortByOptions, pageSize, range },
    {
      headers: headersProvider(),
    },
  );

export const getAgreementsInApprovalList = ({
  page,
  pageSize,
  filterOptions,
  sortByOptions,
}) =>
  axios.post(
    `${constants.apiHost}/agreements/ApprovalsList`,
    { page: page, filterOptions, sortByOptions, pageSize },
    {
      headers: headersProvider(),
    },
  );

export const getAgreementsInSigningList = ({
  page,
  pageSize,
  filterOptions,
  sortByOptions,
  signal,
}) =>
  axios.post(
    `${constants.apiHost}/agreements/SigningList`,
    { page: page, filterOptions: filterOptions, sortByOptions, pageSize },
    {
      headers: headersProvider(),
      signal,
    },
  );

export const getAgreementsInSignedList = ({
  page,
  pageSize,
  filterOptions,
  year,
  sortByOptions,
}) =>
  axios.post(
    `${constants.apiHost}/agreements/SignedList`,
    { page: page, filterOptions, sortByOptions, pageSize, year },
    {
      headers: headersProvider(),
    },
  );

export const getAgreementTypesApi = (signal) =>
  axios.get(`${constants.apiHost}/agreements/get-distinct-types`, {
    headers: headersProvider(),
    signal,
  });

export const getTemplateTypesApi = () =>
  axios.get(`${constants.apiHost}/agreements/get-template-types`, {
    headers: headersProvider(),
  });

export const getAgreementTitleApi = () =>
  axios.get(`${constants.apiHost}/agreements/get-distinct-titles`, {
    headers: headersProvider(),
  });

export const getAgreementByStatus = () =>
  axios.get(`${constants.apiHost}/agreements/get-agreement-by-status`, {
    headers: headersProvider(),
  });

export const createEditorField = ({ fieldName, agreementId }) =>
  axios.post(
    `${constants.apiHost}/agreements/editor-field/${agreementId}`,
    { fieldName },
    {
      headers: headersProvider(),
    },
  );

export const agreementLocation = ({ id }) =>
  axios.get(`${constants.apiHost}/agreements/getlocation/${id}`, {
    headers: headersProvider(),
  });

export const deleteEditorField = ({ fieldName, agreementId }) =>
  axios.put(
    `${constants.apiHost}/agreements/editor-field/${agreementId}`,
    { fieldName },
    {
      headers: headersProvider(),
    },
  );

export const sendForExternalReview = ({
  agreementId,
  email,
  messageForExternalReview,
  ccemails,
}) =>
  //
  axios.post(
    `${constants.apiHost}/agreement/TaskForExternalReview`,
    {
      agreementId: agreementId,
      emailAddress: email,
      emailContent: messageForExternalReview,
      ccemails,
    },
    {
      headers: headersProvider(),
    },
  );

export const getEditorField = ({ agreementId }) =>
  axios.get(`${constants.apiHost}/agreements/editor-field/${agreementId}`, {
    headers: headersProvider(),
  });

export const getRevisions = ({ documentEditorId }) =>
  axios.get(`${constants.apiHost}/docs/fetchRevisions/${documentEditorId}`, {
    headers: headersProvider(),
  });

export const fetchRevisionsHistoryLinks = (documentId, revisionId) =>
  axios.post(
    `${constants.apiHost}/docs/fetchRevisionContent`,
    {
      documentId: documentId,
      revisionId: revisionId,
    },
    {
      headers: headersProvider(),
    },
  );

export const getUser = () =>
  axios.get(`${constants.apiHost}/agreements/user/details`, {
    headers: headersProvider(),
  });

export const getRegisterUserApi = () =>
  axios.get(`${constants.apiHost}/agreements/register-user`, {
    headers: headersProvider(),
  });

export const bulkAgreementUploadApi = ({ formData }) =>
  axios.post(
    `${constants.apiHost}/agreements/bulk-agreement/create`,
    formData,
    {
      headers: {
        ...headersProvider(),
        "Content-Type": "multipart/form-data",
      },
    },
  );

export const createBulkAgreements = ({ formDataObject }) => {
  return axios.post(
    `${constants.apiHost}/agreements/bulk-agreement/createbulkAgreements`,
    formDataObject,
    {
      headers: {
        ...headersProvider(),
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const getAgreementsInReviewCsvDownload = ({
  page,
  sortByOptions,
  filterOptions,
}) =>
  axios.post(
    `${constants.apiHost}/agreementinreview/csv`,
    {
      page,
      filterOptions,
      sortByOptions,
    },
    {
      headers: headersProvider(),
    },
  );

export const getSignedAgreementCSV = ({ filterOptions, sortByOptions } = {}) =>
  axios.post(
    `${constants.apiHost}/agreementssigned/csv`,
    {
      filterOptions,
      sortByOptions,
    },
    {
      headers: headersProvider(),
    },
  );

export const getAgreementsInApproveCsvDownload = ({
  page,
  sortByOptions,
  filterOptions,
}) =>
  axios.post(
    `${constants.apiHost}/agreementinapprove/csv`,
    {
      page,
      filterOptions,
      sortByOptions,
    },
    {
      headers: headersProvider(),
    },
  );

export const getAgreementsSigningCsvDownload = ({
  page,
  sortByOptions,
  filterOptions,
  signal,
}) =>
  axios.post(
    `${constants.apiHost}/agreementinsigning/csv`,
    {
      page,
      filterOptions,
      sortByOptions,
    },
    {
      headers: headersProvider(),
      signal,
    },
  );

export const getAgreementsCsvDownload = ({
  page,
  sortByOptions,
  filterOptions,
  listType,
}) =>
  axios.post(
    `${constants.apiHost}/agreement/csv`,
    {
      page,
      filterOptions,
      sortByOptions,
      listType,
    },
    {
      headers: headersProvider(),
    },
  );

export const getAgreementsDocsLockerCsvDownload = ({
  page,
  sortByOptions,
  filterOptions,
}) =>
  axios.post(
    `${constants.apiHost}/agreements/docslockercasv`,
    {
      page,
      filterOptions,
      sortByOptions,
    },
    {
      headers: headersProvider(),
    },
  );
export const getuserMail = ({ id }) =>
  axios.post(
    `${constants.apiHost}/getuseremail`,
    {
      id,
    },
    {
      headers: headersProvider(),
    },
  );

export const getuserIdbyMail = ({ email }) =>
  axios.post(
    `${constants.apiHost}/getUserId`,
    {
      email,
    },
    {
      headers: headersProvider(),
    },
  );

export const updateRenewalStatus = ({ status, id }) =>
  axios.put(
    `${constants.apiHost}/updateRenewalStatus`,
    {
      id,
      status,
    },
    {
      headers: headersProvider(),
    },
  );

export const closeAgreement = ({
  agreementId,
  actionText,
  closeDate,
  closeReason,
}) =>
  axios.put(
    `${constants.apiHost}/agreements/close/${agreementId}`,
    {
      actionText,
      closeDate,
      closeReason,
    },
    {
      headers: headersProvider(),
    },
  );

export const getObStatusForAg = ({ pageNumber, pageSize, filters, sortBy }) =>
  axios.post(
    `${constants.apiHost}/getObStatus`,
    {
      filters,
      sortOptions: sortBy,
      page: pageNumber,
      pageSize,
    },
    {
      headers: headersProvider(),
    },
  );

export const updateObStatus = ({ obStatus, agreementId }) =>
  axios.put(
    `${constants.apiHost}/updateObStatus`,
    {
      obStatus,
      agreementId,
    },
    {
      headers: headersProvider(),
    },
  );

export const getGraphPdf = ({ documentId, format = "pdf" }) =>
  axios.get(`${constants.apiHost}/agreements/graph-pdf`, {
    params: { documentId, format },
    responseType: "arraybuffer",
    headers: headersProvider(),
  });

export const downloadFileProxy = ({ url }) =>
  axios.get(`${constants.apiHost}/agreements/download-proxy`, {
    params: { url },
    responseType: "arraybuffer",
    headers: headersProvider(),
  });

export const downloadGraphFile = async ({ documentId, format = "pdf" }) => {
  const response = await axios.get(
    `${constants.apiHost}/agreements/graph-pdf`,
    {
      params: { documentId, format },
      responseType: "arraybuffer",
      headers: headersProvider(),
    },
  );
  return {
    data: response.data,
    contentType: response.headers["content-type"] || "application/octet-stream",
  };
};
